import React, { useState, useEffect } from "react";
import "./HotelWebsite1.css";

const HotelWebsite1 = () => {
  const [currentPage, setCurrentPage] = useState("home"); // home, hotels, enquiry
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("All");

  // --- STATIC DATA: 30 PREMIUM HOTEL PROPERTIES ---
  const allHotels = [
    { id: 1, name: "The Grand Atlantis", location: "Dubai, UAE", price: "15,000", rating: 5, type: "Resort", img: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=800", amenities: ["Pool", "Spa", "Private Beach"] },
    { id: 2, name: "Marina Bay Sands", location: "Singapore", price: "22,000", rating: 5, type: "Luxury", img: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=800", amenities: ["Infinity Pool", "Casino", "SkyPark"] },
    { id: 3, name: "The Ritz-Carlton", location: "Bali, Indonesia", price: "18,500", rating: 5, type: "Resort", img: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=800", amenities: ["Villas", "Spa", "Ocean View"] },
    { id: 4, name: "Burj Al Arab", location: "Dubai, UAE", price: "85,000", rating: 5, type: "Luxury", img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=800", amenities: ["Butler Service", "Helipad", "Private Chef"] },
    { id: 5, name: "The Savoy", location: "London, UK", price: "35,000", rating: 5, type: "Heritage", img: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=800", amenities: ["Afternoon Tea", "Historic", "City View"] },
    { id: 6, name: "Mandarin Oriental", location: "Bangkok, Thailand", price: "12,000", rating: 5, type: "Resort", img: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=800", amenities: ["Riverfront", "Pool", "Cooking Class"] },
    { id: 7, name: "Shangri-La Hotel", location: "Kuala Lumpur, Malaysia", price: "9,000", rating: 4, type: "Business", img: "https://images.unsplash.com/photo-1549294413-26f195200c16?auto=format&fit=crop&w=800", amenities: ["Gym", "Executive Lounge", "Central"] },
    { id: 8, name: "The Peninsula", location: "Paris, France", price: "45,000", rating: 5, type: "Luxury", img: "https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&w=800", amenities: ["Rooftop Bar", "Spa", "Classic Decor"] },
    { id: 9, name: "InterContinental", location: "Sydney, Australia", price: "16,000", rating: 4, type: "Business", img: "https://images.unsplash.com/photo-1517840901100-8179e982acb7?auto=format&fit=crop&w=800", amenities: ["Harbour View", "Gym", "Lounge"] },
    { id: 10, name: "Santorini Cave Suites", location: "Santorini, Greece", price: "28,000", rating: 5, type: "Boutique", img: "https://images.unsplash.com/photo-1439130490301-25e322d88054?auto=format&fit=crop&w=800", amenities: ["Plunge Pool", "Sunset View", "Breakfast"] },
    { id: 11, name: "Four Seasons Safari Lodge", location: "Serengeti, Tanzania", price: "55,000", rating: 5, type: "Resort", img: "https://images.unsplash.com/photo-1493246318656-5bbd4afb293c?auto=format&fit=crop&w=800", amenities: ["Wildlife Pool", "Safari", "Outdoor Deck"] },
    { id: 12, name: "The Taj Mahal Palace", location: "Mumbai, India", price: "20,000", rating: 5, type: "Heritage", img: "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=800", amenities: ["Historic", "Sea View", "Butler"] },
    { id: 13, name: "Park Hyatt", location: "Tokyo, Japan", price: "30,000", rating: 5, type: "Business", img: "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?auto=format&fit=crop&w=800", amenities: ["Skyline View", "Jazz Bar", "Pool"] },
    { id: 14, name: "Conrad Maldives", location: "Rangali Island, Maldives", price: "70,000", rating: 5, type: "Resort", img: "https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?auto=format&fit=crop&w=800", amenities: ["Undersea Rest.", "Water Villa", "Dive Centre"] },
    { id: 15, name: "Fairmont Lake Louise", location: "Banff, Canada", price: "25,000", rating: 4, type: "Resort", img: "https://images.unsplash.com/photo-1519449556851-5720b33024e7?auto=format&fit=crop&w=800", amenities: ["Lakefront", "Hiking", "Winter Sports"] },
    { id: 16, name: "Raffles Hotel", location: "Singapore", price: "40,000", rating: 5, type: "Heritage", img: "https://images.unsplash.com/photo-1544124499-58912cbddaad?auto=format&fit=crop&w=800", amenities: ["Garden", "Butler", "Historic Bar"] },
    { id: 17, name: "Capella Ubud", location: "Bali, Indonesia", price: "38,000", rating: 5, type: "Boutique", img: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=800", amenities: ["Tent Suites", "Jungle Pool", "Culture"] },
    { id: 18, name: "Rosewood", location: "New York, USA", price: "48,000", rating: 5, type: "Luxury", img: "https://images.unsplash.com/photo-1444201983204-c43cbd584d93?auto=format&fit=crop&w=800", amenities: ["City View", "Concierge", "Fitness"] },
    { id: 19, name: "Hotel Danieli", location: "Venice, Italy", price: "29,000", rating: 5, type: "Heritage", img: "https://images.unsplash.com/photo-1514890547357-a9ee288728e0?auto=format&fit=crop&w=800", amenities: ["Canal View", "Roof Terrace", "Antiques"] },
    { id: 20, name: "Aman Tokyo", location: "Tokyo, Japan", price: "60,000", rating: 5, type: "Luxury", img: "https://images.unsplash.com/photo-1503174971373-b1f69850bbd6?auto=format&fit=crop&w=800", amenities: ["Spa", "Zen Design", "High Floor"] },
    { id: 21, name: "Oberoi Amarvilas", location: "Agra, India", price: "42,000", rating: 5, type: "Luxury", img: "https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=800", amenities: ["Taj View", "Pool", "Lawn"] },
    { id: 22, name: "The Wynn", location: "Las Vegas, USA", price: "18,000", rating: 5, type: "Business", img: "https://images.unsplash.com/photo-1505773508401-e26ca9845131?auto=format&fit=crop&w=800", amenities: ["Casino", "Golf", "Shopping"] },
    { id: 23, name: "One&Only Reethi Rah", location: "Maldives", price: "95,000", rating: 5, type: "Resort", img: "https://images.unsplash.com/photo-1506929196901-d6273969322d?auto=format&fit=crop&w=800", amenities: ["Beach Villas", "Kids Club", "Yacht"] },
    { id: 24, name: "W Barcelona", location: "Barcelona, Spain", price: "21,000", rating: 5, type: "Boutique", img: "https://images.unsplash.com/photo-1582610116397-edb318610fca?auto=format&fit=crop&w=800", amenities: ["Beachfront", "DJ", "Pool Party"] },
    { id: 25, name: "Claridge's", location: "London, UK", price: "52,000", rating: 5, type: "Luxury", img: "https://images.unsplash.com/photo-1551882547-ff43c63fedfe?auto=format&fit=crop&w=800", amenities: ["Art Deco", "Service", "Lounge"] },
    { id: 26, name: "Grand Hyatt", location: "Mumbai, India", price: "8,500", rating: 4, type: "Business", img: "https://images.unsplash.com/photo-1512918728675-ed5a9ecdebfd?auto=format&fit=crop&w=800", amenities: ["Conferences", "Pool", "Buffet"] },
    { id: 27, name: "Explora Patagonia", location: "Chile", price: "45,000", rating: 5, type: "Resort", img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=800", amenities: ["Mountain View", "Guide", "Eco-friendly"] },
    { id: 28, name: "Palazzo Versace", location: "Gold Coast, Australia", price: "19,000", rating: 5, type: "Luxury", img: "https://images.unsplash.com/photo-1560200353-ce0a76b1d438?auto=format&fit=crop&w=800", amenities: ["Designer", "Pool", "Marina"] },
    { id: 29, name: "Waldorf Astoria", location: "Rome, Italy", price: "33,000", rating: 5, type: "Heritage", img: "https://images.unsplash.com/photo-1551133990-7ccc23980f16?auto=format&fit=crop&w=800", amenities: ["Garden", "Fine Dining", "Spa"] },
    { id: 30, name: "Banyan Tree", location: "Phuket, Thailand", price: "24,000", rating: 5, type: "Resort", img: "https://images.unsplash.com/photo-1583037189850-1921ae7c6c22?auto=format&fit=crop&w=800", amenities: ["Pool Villa", "Golf", "Romantic Dining"] },
  ];

  const categories = ["All", "Luxury", "Resort", "Business", "Heritage", "Boutique"];

  const filteredHotels = allHotels.filter(h => 
    (filterType === "All" || h.type === filterType) &&
    (h.name.toLowerCase().includes(searchQuery.toLowerCase()) || h.location.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <div className="hotelwebsite1-container">
      {/* NAVIGATION */}
      <nav className="hotelwebsite1-nav">
        <div className="hotelwebsite1-logo" onClick={() => setCurrentPage("home")}>
          <span>ZOTRAI</span>
        </div>
        <div className="hotelwebsite1-nav-links">
          <span onClick={() => setCurrentPage("home")}>Explore</span>
          <span onClick={() => {setCurrentPage("hotels"); setFilterType("All")}}>All Properties</span>
          <span className="hotelwebsite1-cta" onClick={() => setCurrentPage("enquiry")}>Book With Us</span>
        </div>
      </nav>

      {/* HOME PAGE */}
      {currentPage === "home" && (
        <div className="hotelwebsite1-content">
          <section className="hotelwebsite1-hero">
            <div className="hotelwebsite1-hero-overlay">
              <h1 style={{color: "#fff"}}>Exceptional Stays, <br/>Unforgettable Memories.</h1>
              <p style={{color: "#fff"}}>Discover the finest hotel properties across the globe.</p>
              
              <div className="hotelwebsite1-search-box">
                <input 
                  type="text" 
                  placeholder="Where do you want to stay? (e.g. Dubai, Resort...)" 
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button onClick={() => setCurrentPage("hotels")}>Find Hotels</button>
              </div>
            </div>
          </section>

          <section className="hotelwebsite1-section">
            <div className="hotelwebsite1-section-header">
              <h2>Featured Properties</h2>
              <span onClick={() => setCurrentPage("hotels")}>View All Hotels →</span>
            </div>
            <div className="hotelwebsite1-grid">
              {allHotels.slice(0, 9).map(h => (
                <div className="hotelwebsite1-card" key={h.id}>
                  <div className="hotelwebsite1-card-img" style={{backgroundImage: `url(${h.img})`}}>
                    <span className="hotelwebsite1-card-tag">{h.type}</span>
                  </div>
                  <div className="hotelwebsite1-card-body">
                    <div className="hotelwebsite1-rating">{"★".repeat(h.rating)}</div>
                    <h3>{h.name}</h3>
                    <p className="hotelwebsite1-loc">📍 {h.location}</p>
                    <div className="hotelwebsite1-amenities">
                      {h.amenities.map(a => <span key={a}>{a}</span>)}
                    </div>
                    <div className="hotelwebsite1-card-footer">
                      <div className="hotelwebsite1-price">₹{h.price}<span>/night</span></div>
                      <button className="hotelwebsite1-btn-sm" onClick={() => setCurrentPage("enquiry")}>Book Stay</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      )}

      {/* LISTING PAGE */}
      {currentPage === "hotels" && (
        <div className="hotelwebsite1-page-wrapper">
          <div className="hotelwebsite1-listing-header">
            <h2>Find Your Perfect Stay</h2>
            <div className="hotelwebsite1-filters">
              {categories.map(c => (
                <button 
                  key={c} 
                  className={filterType === c ? "active" : ""} 
                  onClick={() => setFilterType(c)}
                >
                  {c}
                </button>
              ))}
            </div>
          </div>

          <div className="hotelwebsite1-grid">
            {filteredHotels.length > 0 ? filteredHotels.map(h => (
              <div className="hotelwebsite1-card" key={h.id}>
                <div className="hotelwebsite1-card-img" style={{backgroundImage: `url(${h.img})`}}>
                  <span className="hotelwebsite1-card-tag">{h.type}</span>
                </div>
                <div className="hotelwebsite1-card-body">
                  <div className="hotelwebsite1-rating">{"★".repeat(h.rating)}</div>
                  <h3>{h.name}</h3>
                  <p className="hotelwebsite1-loc">📍 {h.location}</p>
                  <div className="hotelwebsite1-card-footer">
                    <div className="hotelwebsite1-price">₹{h.price}<span>/night</span></div>
                    <button className="hotelwebsite1-btn-sm" onClick={() => setCurrentPage("enquiry")}>Reserve</button>
                  </div>
                </div>
              </div>
            )) : <p className="hotelwebsite1-no-results">No properties found matching your search.</p>}
          </div>
        </div>
      )}

      {/* ENQUIRY PAGE */}
      {currentPage === "enquiry" && (
        <div className="hotelwebsite1-page-wrapper hotelwebsite1-enquiry-bg">
          <div className="hotelwebsite1-form-box">
             <div className="hotelwebsite1-form-header">
                <h2>Reservation & Inquiry</h2>
                <p>Submit your details and the property manager will reach out to you within 4 hours.</p>
             </div>
             <form className="hotelwebsite1-form" onSubmit={(e) => {e.preventDefault(); alert('Booking Request Received!')}}>
                <div className="hotelwebsite1-form-row">
                  <div className="hotelwebsite1-group">
                    <label>Full Name</label>
                    <input type="text" placeholder="Your Name" required />
                  </div>
                  <div className="hotelwebsite1-group">
                    <label>Email Address</label>
                    <input type="email" placeholder="email@example.com" required />
                  </div>
                </div>
                <div className="hotelwebsite1-form-row">
                  <div className="hotelwebsite1-group">
                    <label>Check-in Date</label>
                    <input type="date" required />
                  </div>
                  <div className="hotelwebsite1-group">
                    <label>No. of Guests</label>
                    <input type="number" min="1" placeholder="2" required />
                  </div>
                </div>
                <div className="hotelwebsite1-group">
                  <label>Special Instructions (Room type, Dietary needs etc.)</label>
                  <textarea rows="4" placeholder="Enter your requirements..."></textarea>
                </div>
                <button type="submit" className="hotelwebsite1-btn-full">Send Request</button>
             </form>
          </div>
        </div>
      )}

      <footer className="hotelwebsite1-footer">
        <p>&copy; 2024 Zotrai Solutions. Premium Hotel Partners.</p>
      </footer>
    </div>
  );
};

export default HotelWebsite1;